import type { HttpErrorResponse } from '@angular/common/http';

import {
  createEntityCollectionStore,
  getEntityCollectionActions,
  ngrxEvent,
  type PickActions,
} from '@core/ngrx-legacy';
import {
  TellentOrgAgreement,
  TellentOrgAgreementCheck,
  TellentOrgAgreementPayload,
} from '@core/tellent-types';

export interface TellentOrgAgreementCheckState extends TellentOrgAgreementCheck {
  id: TellentOrgAgreement['kind'];
}

const idSelector = (entity: { id: string }) => entity.id;
const {
  reducer: AgreementsReducer,
  actions,
  selectors: AgreementsSelectors,
  namespace: AgreementsNamespace,
} = createEntityCollectionStore<TellentOrgAgreementCheckState>()('TellentOrganizationAgreements', {
  customActions: adapter => {
    const defaultActions = getEntityCollectionActions(adapter, idSelector);

    return {
      fetchOne: (state, payload: { id: string }) => defaultActions.fetchOne(state, payload),

      setAgreement: ngrxEvent<TellentOrgAgreementPayload>(),
      setAgreementSuccess: (state, payload: TellentOrgAgreement) =>
        defaultActions.fetchOneSuccess(state, {
          data: { id: payload.kind, needsAgreement: false },
        }),
      setAgreementFailed: ngrxEvent<{ error: HttpErrorResponse }>(),
    };
  },
});

const AgreementsActions: PickActions<typeof actions, 'setAgreement' | 'fetchOne'> = actions;

export { AgreementsActions, AgreementsReducer, AgreementsSelectors, AgreementsNamespace };
